
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Robert Martinez',
      location: 'Philadelphia, PA',
      avatar: 'https://public.readdy.ai/ai/img_res/17776e153500d1fbaf4b8a5c6fccbfad.jpg',
      rating: 5,
      service: 'Complete Roof Replacement',
      review: 'IronCore replaced our entire roof after storm damage. The crew was professional, cleaned up everything, and finished in just two days. Our new roof looks amazing and we feel confident it will protect our home for years to come.'
    },
    {
      name: 'Jennifer Williams',
      location: 'Pittsburgh, PA',
      avatar: 'https://readdy.ai/api/search-image?query=Caucasian%20woman%20in%20her%2040s%20homeowner%20portrait%20with%20genuine%20smile%2C%20standing%20outside%20modern%20home%2C%20casual%20professional%20attire%2C%20natural%20daylight%20with%20residential%20setting%2C%20authentic%20satisfied%20customer%20photo&width=200&height=200&seq=roof-customer-002&orientation=squarish',
      rating: 5,
      service: 'Storm Damage Repair',
      review: 'After a severe hailstorm, IronCore came out the same day for an inspection. They handled everything with our insurance company and made the whole process stress-free. Highly recommend their storm restoration services!'
    },
    {
      name: 'Marcus Johnson',
      location: 'Allentown, PA',
      avatar: 'https://readdy.ai/api/search-image?query=African%20American%20man%20in%20his%2050s%20homeowner%20portrait%20with%20confident%20expression%2C%20standing%20in%20front%20of%20beautiful%20home%20exterior%2C%20business%20casual%20attire%2C%20warm%20natural%20lighting%2C%20authentic%20customer%20review%20photo&width=200&height=200&seq=roof-customer-003&orientation=squarish',
      rating: 5,
      service: 'Siding Installation',
      review: 'We hired IronCore for new siding on our home and the transformation is incredible. The team was punctual, respectful of our property, and the quality of work exceeded our expectations. Our home looks brand new!'
    },
    {
      name: 'Sarah Thompson',
      location: 'Erie, PA',
      avatar: 'https://readdy.ai/api/search-image?query=Blonde%20woman%20in%20her%2030s%20homeowner%20portrait%20with%20warm%20smile%2C%20standing%20outside%20suburban%20home%2C%20casual%20summer%20attire%2C%20bright%20natural%20lighting%20with%20house%20in%20background%2C%20genuine%20customer%20testimonial%20photo&width=200&height=200&seq=roof-customer-004&orientation=squarish',
      rating: 5,
      service: 'Gutter Installation',
      review: 'IronCore installed seamless gutters on our home and the difference is night and day. No more water pooling around our foundation. The crew was efficient and left our yard spotless. Great experience from start to finish.'
    },
    {
      name: 'David Chen',
      location: 'Reading, PA',
      avatar: 'https://readdy.ai/api/search-image?query=Asian%20American%20man%20in%20his%2040s%20homeowner%20portrait%20with%20friendly%20demeanor%2C%20standing%20in%20front%20of%20two%20story%20home%2C%20casual%20weekend%20attire%2C%20natural%20outdoor%20lighting%2C%20authentic%20satisfied%20customer%20photo&width=200&height=200&seq=roof-customer-005&orientation=squarish',
      rating: 5,
      service: 'Roof Inspection & Repair',
      review: 'Called IronCore for a roof inspection before selling our home. They found a few issues, fixed them quickly at a fair price, and provided documentation for the buyers. Professional service and honest pricing.'
    },
    {
      name: 'Amanda Garcia',
      location: 'Scranton, PA',
      avatar: 'https://readdy.ai/api/search-image?query=Hispanic%20woman%20in%20her%2030s%20homeowner%20portrait%20with%20bright%20smile%2C%20standing%20outside%20beautiful%20home%2C%20stylish%20casual%20attire%2C%20golden%20hour%20natural%20lighting%2C%20genuine%20happy%20customer%20photo&width=200&height=200&seq=roof-customer-006&orientation=squarish',
      rating: 5,
      service: 'Complete Exterior Renovation',
      review: 'IronCore did our roof, siding, and gutters all at once. The coordination was seamless and the results are stunning. Our neighbors keep asking who did the work. Best investment we have made in our home!'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-100 to-gray-50 relative z-10">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
            <span className="text-xs uppercase tracking-widest font-medium text-gunmetal">
              Customer Reviews
            </span>
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-matte-black mb-6">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gunmetal max-w-2xl mx-auto">
            Don't just take our word for it. Here's what homeowners across the DFW area have to say about their experience with IronCore Roofing and Exteriors.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xl text-neon-green"></i>
              ))}
            </div>
            <span className="text-matte-black font-semibold ml-2">5.0</span>
            <span className="text-gunmetal">Average Rating</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-neon-green/40 group"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg text-neon-green"></i>
                  ))}
                </div>
                <span className="text-xs font-medium text-neon-green bg-neon-green/10 px-3 py-1 rounded-full">
                  {testimonial.service}
                </span>
              </div>
              
              <p className="text-sm text-gunmetal leading-relaxed mb-6">
                "{testimonial.review}"
              </p>
              
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 border-2 border-neon-green/30 group-hover:border-neon-green transition-colors">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-base font-bold text-matte-black">{testimonial.name}</p>
                  <div className="flex items-center gap-1 text-gunmetal">
                    <i className="ri-map-pin-line text-sm text-neon-green"></i>
                    <span className="text-sm">{testimonial.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-6 bg-matte-black rounded-xl px-8 py-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-neon-green/20 flex items-center justify-center">
                <i className="ri-google-fill text-2xl text-neon-green"></i>
              </div>
              <div className="text-left">
                <p className="text-white font-bold">Google Reviews</p>
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-neon-green"></i>
                  ))}
                  <span className="text-gray-400 text-sm ml-1">5.0 (127 reviews)</span>
                </div>
              </div>
            </div>
            <div className="w-px h-12 bg-gray-700"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-neon-green/20 flex items-center justify-center">
                <i className="ri-facebook-circle-fill text-2xl text-neon-green"></i>
              </div>
              <div className="text-left">
                <p className="text-white font-bold">Facebook Reviews</p>
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-neon-green"></i>
                  ))}
                  <span className="text-gray-400 text-sm ml-1">4.9 (89 reviews)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
